module.exports = __webpack_public_path__ + "static/media/small-white-hearts.412767c1.svg";